import React, { Component } from 'react'

import { useTranslation } from 'react-i18next'

import { keys, isObject } from 'lodash'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash } from '@fortawesome/pro-light-svg-icons'
import { Modal, Button, Form, Input, Slider, Tooltip, DatePicker } from 'antd'

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24,
	},
}

const marks = {
	1: 'Not at all',
	2: 'Partially',
	3: 'Highly',
}

export const ProjectModal = (props: any) => {
	const [form] = Form.useForm()
	const { t } = useTranslation()

	const handleFormSubmit = () => {
		console.log('handleFormSubmit')
		form.validateFields()
			.then((values) => {
				console.log('validated', values)
				props.onSave(values)
				props.onHide()
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo)
			})
	}

	const footer = (
		<div style={{ display: 'flex' }}>
			<Button
				style={{ marginRight: 'auto' }}
				onClick={() => {
					props.onHide()
				}}
			>
				Cancel
			</Button>
			<Button onClick={handleFormSubmit} type="primary">
				Save
			</Button>
		</div>
	)

	return (
		<Modal
			open={true}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText="Close"
			footer={footer}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={(values) => {
					props.onChange(props.id, values)
					props.onHide()
				}}
				initialValues={props.values}
			>
				<Form.Item
					name="description"
					label={t('models.project.fields.description')}
					rules={[
						{
							max: 80,
							message: 'Please shorten your goal (80 characters max)',
						},
					]}
				>
					<Input.TextArea
						rows={5}
						placeholder={t('models.project.fields.description_explanation')}
					></Input.TextArea>
				</Form.Item>
				<Form.Item
					name="fishboneDescription"
					label={t('models.project.fields.fishbone_description')}
					rules={[
						{
							max: 200,
							message: 'Please shorten your text (200 characters max)',
						},
					]}
				>
					<Input.TextArea
						rows={7}
						placeholder={t('models.project.fields.fishbone_description_explanation')}
					></Input.TextArea>
				</Form.Item>
				<Form.Item name="responsible" label="Responsible name">
					<Input></Input>
				</Form.Item>

				<div className="d-flex">
					<Form.Item name="fishboneStartOn" label="Start">
						<DatePicker format="L"></DatePicker>
					</Form.Item>
					<Form.Item name="fishboneEndOn" label="End">
						<DatePicker format="L"></DatePicker>
					</Form.Item>
				</div>
			</Form>
		</Modal>
	)
}

export default ProjectModal
